package com.wiz3r.database

import app.cash.sqldelight.SuspendingTransacter
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlDriver
import app.cash.sqldelight.db.SqlSchema
import com.wiz3r.database.shared.newInstance
import com.wiz3r.database.shared.schema
import kotlin.Unit

public interface Wiz3rDatabase : SuspendingTransacter {
  public val schemaQueries: SchemaQueries

  public companion object {
    public val Schema: SqlSchema<QueryResult.AsyncValue<Unit>>
      get() = Wiz3rDatabase::class.schema

    public operator fun invoke(driver: SqlDriver): Wiz3rDatabase =
        Wiz3rDatabase::class.newInstance(driver)
  }
}
